import { type RefObject, useMemo } from 'react';
import { useForm } from 'react-hook-form';

import { useRedeemGiftCard } from '../useRedeemGiftCard';

export const useRedeemGiftCardForm = (props: UseRedeemGiftCardFormProps) => {
  const { onRedeemSuccess, generateAwsWafTokenRef } = props;

  const form = useForm<GiftCardRedemptionFormData>({
    mode: 'onBlur',
    defaultValues: {
      giftCardCode: '',
      giftCardRegistrationCode: '',
    },
  });

  const { redeemGiftCard } = useRedeemGiftCard({ generateAwsWafTokenRef });
  const { handleSubmit } = form;

  const submitForm = useMemo<() => Promise<void>>(() => {
    return handleSubmit(async (formData) => {
      const payload = {
        code: formData.giftCardCode,
        regCode: formData.giftCardRegistrationCode,
      };

      const hasSubmittedSuccessfully = await redeemGiftCard(payload);

      if (!hasSubmittedSuccessfully) return;

      onRedeemSuccess?.();
      form.reset();
    });
  }, [form, handleSubmit, redeemGiftCard, onRedeemSuccess]);

  // ────────────────────────────────────────────────────────────────────

  return { form, submitForm, redeemGiftCard };
};

// ─── Types ───────────────────────────────────────────────────────────────────

type UseRedeemGiftCardFormProps = {
  onRedeemSuccess?: () => void;
  generateAwsWafTokenRef: RefObject<() => Promise<string>>;
};

type GiftCardRedemptionFormData = Readonly<{
  giftCardCode: string;
  giftCardRegistrationCode: string;
}>;
